// extracted by mini-css-extract-plugin
export default {"holder":"BZvdx33WZPnKzEs2+orWNw=="};